// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1CX0S","savePackageButton":"ClientWallet_savePackageButton__2tqFr"};